import { ColorOptions, Spacer, SpacerNew } from '@jfs/ui-new'
import { TextInputNew } from '../../../components/AdminInputs'
import { Name, required } from '@jfs/utils'
import * as Yup from 'yup'
import { actionMenuStrings } from '../../../components/ActionMenu/ActionsMenu'
import { DatePickerReact } from '../../../components/DatePicker'
import { DropdownOptimised } from '../../../components/DropdownNew'
import { DropdownTypes } from '../../../components/DropdownNew/types'
import { dataExport } from '../../../data'
import { styles } from '../styles'

const NameNotMandatory = Yup.string()
  .trim()
  .max(50, 'Too Long Name!')
  .matches(/^[a-zA-Z]*(\s[a-zA-Z]*)?$/, 'Only Alphabets are allowed.')
  .nullable()

const numberValidation = Yup.string()
  .required('Required')
  .min(1, 'Please enter a number')
  .matches(/^[0-9]*$/, 'Only digits 0-9 are allowed.')
  .nullable()
const textinputStyle = {
  type: 'body12',
  borderColor: 'ITEM_SEPARATOR' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: 'BLACK_21',
  labelFontSize: 12,
  fontSize: 12,
  paddingHorizontal: 16,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 16,
}

export const MerchantSearch = (): any => [
  {
    formItems: [
      {
        fieldName: 'midCin',
        ComponentName: TextInputNew,
        placeholder: 'Enter Merchant ID',
        autoFocus: true,
        ...textinputStyle,
        testID: 'midCin',
        accessibilityLabel: 'midCin',
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]

const getExport = (exportFiuFile: any) => {
  return exportFiuFile !== undefined
    ? {
        fieldName: 'exportRecord',
        ComponentName: DropdownOptimised,
        placeHolder: actionMenuStrings.export,
        data: dataExport,
        onButtonPress: exportFiuFile,
        type: DropdownTypes.RADIO_BUTTON,
        marginTop: 32,
      }
    : {
        fieldName: 'spacer',
        ComponentName: Spacer,
      }
}

export const CinDetailsForm = (
  calendarIcon: any,
  isEdit: boolean = false,
  dateValue: string,
  exportFiuFile?: any,
): any => [
  {
    actionTitle: 'Proceed',
    key: 'cinDeatails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'cinNumber',
            ComponentName: TextInputNew,
            label: 'CIN Number*',
            placeholder: '',
            validationSchema: numberValidation,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'cinNumber',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'cinDate',
            ComponentName: isEdit ? DatePickerReact : TextInputNew,
            label: 'Date of Incorporation*',
            placeholder: '',
            dateValue: dateValue ?? '',
            dateFormat: 'yyyy-MM-dd',
            maxDate: new Date().setDate(new Date().getDate() + 365 * 15), //15 years in future
            validationSchema: required,
            editable: isEdit,
            showYearDropdown: true,
            scrollableYearDropdown: true,
            ...styles.textinputStyle(isEdit),
            rightComponent: isEdit ? calendarIcon : undefined,
            testID: 'cinDate',
          },
          getExport(exportFiuFile),
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const DirectorForm = (
  calendarIcon: any,
  formData: any,
  isEdit: boolean = false,
  showAction: boolean = false,
  isBeginSet: boolean = false,
  isEditPressed: boolean,
  beginDate?: string,
): any => [
  {
    actionTitle: 'Proceed',
    key: 'directorDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'din',
            ComponentName: TextInputNew,
            label: 'Director ID*',
            placeholder: '',
            editable: !isEditPressed && isEdit,
            validationSchema: numberValidation,
            ...styles.textinputStyle(!isEditPressed && isEdit),
            color: 'BLACK_21',
            testID: 'din',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'firstName',
            ComponentName: TextInputNew,
            label: 'Director First Name*',
            placeholder: '',
            editable: isEdit,
            validationSchema: Name,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'firstName',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'middleName',
            ComponentName: TextInputNew,
            label: 'Director Middle Name',
            placeholder: '',
            editable: isEdit,
            validationSchema: NameNotMandatory,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'middleName',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'lastName',
            ComponentName: TextInputNew,
            label: 'Director Last Name*',
            placeholder: '',
            editable: isEdit,
            validationSchema: Name,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'lastName',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'dummyPlaceHolder',
            ComponentName: TextInputNew,
            label: '',
            hide: !showAction,
            placeholder: '',
            editable: false,
            enabled: false,
            ...styles.textinputStyle(false),
            testID: 'dummyPlaceHolder',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'dob',
            ComponentName: isEdit ? DatePickerReact : TextInputNew,
            label: 'Director Date of Birth*',
            placeholder: '',
            dateValue: formData?.dob?.length > 0 ? formData?.dob : '',
            dateFormat: 'yyyy-MM-dd',
            maxDate: new Date().setDate(new Date().getDate() - 365 * 18),
            editable: isEdit,
            showYearDropdown: true,
            validationSchema: required,
            scrollableYearDropdown: true,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: 7,
            rightComponent: isEdit ? calendarIcon : undefined,
            testID: 'dob',
          },
          {
            fieldName: 'beginAt',
            ComponentName: isEdit ? DatePickerReact : TextInputNew,
            label: 'Date of Joining*',
            placeholder: '',
            dateValue: formData?.beginAt?.length > 0 ? formData?.beginAt : '',
            dateFormat: 'yyyy-MM-dd',
            minDate: new Date().setDate(new Date().getDate() - 365 * 15),
            showYearDropdown: true,
            scrollableYearDropdown: true,
            maxDate: new Date().setDate(new Date().getDate()),
            editable: isEdit,
            validationSchema: required,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: 7,
            rightComponent: isEdit ? calendarIcon : undefined,
            testID: 'beginAt',
          },
          {
            fieldName: 'endAt',
            ComponentName: isBeginSet ? (isEdit ? DatePickerReact : TextInputNew) : SpacerNew,
            label: 'Date of Exit*',
            placeholder: '',
            dateValue: formData?.endAt?.length > 0 ? formData?.endAt : '',
            dateFormat: 'yyyy-MM-dd',
            showYearDropdown: true,
            scrollableYearDropdown: true,
            maxDate: new Date().setDate(new Date().getDate() + 365 * 15), //15 years in future
            editable: isEdit,
            disabled: !isBeginSet,
            validationSchema: required,
            minDate: new Date().setDate(new Date().getDate()),
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: 7,
            rightComponent: isEdit ? calendarIcon : undefined,
            testID: 'endAt',
          },
          {
            fieldName: 'action',
            ComponentName: TextInputNew,
            label: 'Action',
            hide: !showAction,
            placeholder: '',
            editable: false,
            enabled: false,
            ...styles.textinputStyle(false),
            testID: 'action',
            value: formData?.action,
          },
          {
            fieldName: 'directorReferenceId',
            ComponentName: TextInputNew,
            label: '',
            hide: true,
            placeholder: '',
            editable: false,
            value: formData?.directorReferenceId,
            testID: 'directorReferenceId',
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const UboForm = (
  calendarIcon: any,
  itemData: any,
  isEdit: boolean = false,
  showAction: boolean = false,
): any => [
  {
    actionTitle: 'Proceed',
    key: 'uboDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'uboFname',
            ComponentName: TextInputNew,
            label: 'UBO First Name*',
            placeholder: '',
            editable: isEdit,
            validationSchema: Name,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'uboFname',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'uboMname',
            ComponentName: TextInputNew,
            label: 'UBO Middle Name',
            placeholder: '',
            editable: isEdit,
            validationSchema: NameNotMandatory,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'uboMname',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'uboLname',
            ComponentName: TextInputNew,
            label: 'UBO Last Name*',
            placeholder: '',
            editable: isEdit,
            validationSchema: Name,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'uboLname',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'uboDob',
            ComponentName: isEdit ? DatePickerReact : TextInputNew,
            label: 'UBO Date of Birth*',
            placeholder: '',
            dateValue: itemData?.dob?.length > 0 ? itemData?.dob : '',
            dateFormat: 'yyyy-MM-dd',
            maxDate: new Date().setDate(new Date().getDate() - 365 * 18),
            showYearDropdown: true,
            scrollableYearDropdown: true,
            editable: isEdit,
            validationSchema: required,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: 7,
            rightComponent: isEdit ? calendarIcon : undefined,
            testID: 'directorDob',
          },
          {
            fieldName: 'action',
            ComponentName: TextInputNew,
            label: 'Action',
            hide: !showAction,
            placeholder: '',
            editable: false,
            enabled: false,
            testID: 'action',
            ...styles.textinputStyle(false),
            value: itemData?.action,
          },
          {
            fieldName: 'beneficialOwnerReferenceId',
            ComponentName: TextInputNew,
            label: '',
            hide: true,
            placeholder: '',
            editable: false,
            testID: 'beneficialOwnerReferenceId',
            value: itemData?.beneficialOwnerReferenceId,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const AuthorisedForm = (
  calendarIcon: any,
  itemData: any,
  isEdit: boolean = false,
  showAction: boolean = false,
): any => [
  {
    actionTitle: 'Proceed',
    key: 'authorisedDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'authSigFirstname',
            ComponentName: TextInputNew,
            label: 'Authorised First Name*',
            placeholder: '',
            editable: isEdit,
            validationSchema: Name,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'authSigFirstname',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'authSigMidname',
            ComponentName: TextInputNew,
            label: 'Authorised Middle Name',
            placeholder: '',
            editable: isEdit,
            validationSchema: NameNotMandatory,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'authSigMidname',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'authSigLastname',
            ComponentName: TextInputNew,
            label: 'Authorised Last Name*',
            placeholder: '',
            editable: isEdit,
            validationSchema: Name,
            ...styles.textinputStyle(isEdit),
            color: 'BLACK_21',
            testID: 'authSigLastname',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'authSigDOB',
            ComponentName: isEdit ? DatePickerReact : TextInputNew,
            label: 'Authorised Date of Birth*',
            placeholder: '',
            dateValue: itemData?.dob?.length > 0 ? itemData?.dob : '',
            dateFormat: 'yyyy-MM-dd',
            maxDate: new Date().setDate(new Date().getDate() - 365 * 18),
            showYearDropdown: true,
            scrollableYearDropdown: true,
            editable: isEdit,
            validationSchema: required,
            ...styles.textinputStyle(isEdit),
            paddingHorizontal: 7,
            rightComponent: isEdit ? calendarIcon : undefined,
            testID: 'authSigDOB',
          },
          {
            fieldName: 'action',
            ComponentName: TextInputNew,
            label: 'Action',
            hide: !showAction,
            placeholder: '',
            editable: false,
            enabled: false,
            testID: 'action',
            ...styles.textinputStyle(false),
            value: itemData?.action,
          },
          {
            fieldName: 'authorisedSignatoryReferenceId',
            ComponentName: TextInputNew,
            label: '',
            hide: true,
            placeholder: '',
            editable: false,
            testID: 'authorisedSignatoryReferenceId',
            value: itemData?.authorisedSignatoryReferenceId,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]

export const authorizedListTitles = [
  {
    title: 'Authorised First Name',
  },
  {
    title: 'Authorised Middle Name',
  },
  {
    title: 'Authorised Last Name',
  },
  {
    title: 'DOB',
  },
  {
    title: '',
  },
  {
    title: 'Status',
  },
  {
    title: 'Action',
  },
]

export const authorizedEditListTitles = [
  { title: 'Authorised First Name' },
  {
    title: 'Authorised Middle Name',
  },
  { title: 'Authorised Last Name' },
  {
    title: 'DOB',
  },
  {
    title: '',
  },
  {
    title: 'Action',
  },
  {
    title: 'Undo',
  },
]

export const uboListTitles = [
  {
    title: 'UBO First Name',
  },
  {
    title: 'UBO Middle Name',
  },
  {
    title: 'UBO Last Name',
  },
  {
    title: 'DOB',
  },
  {
    title: '',
  },
  {
    title: 'Status',
  },
  {
    title: 'Action',
  },
]

export const uboEditListTitles = [
  {
    title: 'UBO First Name',
  },
  {
    title: 'UBO Middle Name',
  },
  {
    title: 'UBO Last Name',
  },
  {
    title: 'DOB',
  },
  {
    title: '',
  },
  {
    title: 'Action',
  },
  {
    title: 'Undo',
  },
]

export const authorizedListColumnFlex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
}

export const authorizedEditListColumnFlex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
}

export const uboListColumnFlex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
}

export const uboEditListColumnFlex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
}

export const directorListTitles = [
  {
    title: 'Director ID',
  },
  {
    title: 'First Name',
  },
  {
    title: 'Middle Name',
  },
  {
    title: 'Last Name',
  },
  {
    title: 'DOB',
  },
  {
    title: 'Date of Joining',
  },
  {
    title: 'Date of Exit',
  },
  {
    title: '',
  },
  {
    title: 'Status',
  },
  {
    title: 'Action',
  },
]

export const directorEditListTitles = [
  {
    title: 'Director ID',
  },
  {
    title: 'First Name',
  },
  {
    title: 'Middle Name',
  },
  {
    title: 'Last Name',
  },
  {
    title: 'DOB',
  },
  {
    title: 'Date of Joining',
  },
  {
    title: 'Date of Exit',
  },
  {
    title: '',
  },
  {
    title: 'Action',
  },
  {
    title: 'Undo',
  },
]
export const directorListColumnFlex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
}
export const directorEditListColumnFlex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
}
